<template>
  <div
    style="
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    "
  >
    <div id="discover-code-container" class="code-container">
      <div
        v-for="i in 9"
        :id="`discover-button-${i}`"
        :ref="i"
        :key="i"
        class="code-button noSelect"
      >
        {{ i }}
      </div>
      <div id="discover-tap-finger" class="tap-finger"></div>
    </div>
    <div class="explainer-text">
      Drag bottom-left button to top right corner and then rotate to original
      position.
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import lottie from 'lottie-web'
import interpolate from 'color-interpolate'
//import { buildArcPath, rotateVector } from '@/lib/vector.js'
import { buildArcPath, rotateVector } from '@/lib/vector.js'
import { Bezier } from 'bezier-js'

import * as tapAnimationData from '@/assets/tap_finger.json'

export default {
  name: 'SlideRotateDiscovered',
  data() {
    return {
      tapAnim: undefined,
      gsapTimeline: undefined,
      rotation_t: undefined,
      origins: undefined,
      r: undefined,
      theta0: undefined,
      arc1: undefined,
      arc2: undefined,
    }
  },
  mounted() {
    this.tapAnim = lottie.loadAnimation({
      container: document.getElementById('discover-tap-finger'),
      animationData: tapAnimationData.default,
      renderer: 'svg',
      autoplay: false,
      loop: false,
    })

    setTimeout(() => {
      const button_gap = parseFloat(
        window.getComputedStyle(
          document.getElementById('discover-code-container')
        ).columnGap
      )
      // 1px border
      const button_span =
        parseFloat(
          window.getComputedStyle(document.getElementById('discover-button-1'))
            .width
        ) + 2

      this.buildArcs(button_span, button_gap)

      const colourmap = interpolate(['#cdf4dd', '#468B18'])

      const tl = gsap.timeline({ paused: true, repeat: -1, delay: 1 })

      const callBack = () => {
        console.log('tap1')
        this.tapAnim.playSegments([0, 14], true)
      }
      tl.eventCallback('onStart', callBack)
      tl.eventCallback('onRepeat', callBack)

      tl.addLabel('firstTapDown', 14 / 60)

      tl.to(
        ['#discover-button-7', '#discover-tap-finger'],
        {
          x: button_span + button_gap + 'px',
          y: -button_span - button_gap + 'px',
          duration: 0.5,
          ease: 'linear',
        },
        'firstTapDown+=0.2'
      )

      tl.to(['#discover-button-7', '#discover-button-5'], {
        color: colourmap(0.5),
        borderColor: colourmap(0.5),
        duration: 0.3,
      })

      tl.to(
        ['#discover-button-7', '#discover-tap-finger'],
        {
          x: 2 * (button_span + button_gap) + 'px',
          y: -2 * (button_span + button_gap) + 'px',
          duration: 0.5,
          ease: 'linear',
        },
        'secondSlide'
      )

      tl.to(
        '#discover-button-5',
        {
          x: button_span + button_gap + 'px',
          y: -button_span - button_gap + 'px',
          duration: 0.5,
          ease: 'linear',
        },
        'secondSlide'
      )

      tl.to(
        ['#discover-button-7', '#discover-button-5', '#discover-button-3'],
        {
          color: colourmap(1),
          borderColor: colourmap(1),
          duration: 0.3,
        }
      )

      tl.fromTo(
        this,
        {
          rotation_t: 0,
        },
        {
          // arc2 does not calculate for t = 1 for some reason
          rotation_t: 0.999,
          duration: 1,
          ease: 'linear',
          immediateRender: false,
        }
      )

      tl.to('#discover-code-container', { opacity: 0, duration: 0.5 }, '+=1')
      tl.set(
        [
          '#discover-button-7',
          '#discover-button-5',
          '#discover-button-3',
          '#discover-button-1',
          '#discover-button-9',
          '#discover-tap-finger',
        ],
        { clearProps: 'all' }
      )

      tl.call(() => {
        this.tapAnim.goToAndStop(0)
      }, null)

      tl.to(
        '#discover-code-container',
        { opacity: 1, duration: 0.5, clearProps: 'all' },
        '+=0.5'
      )

      this.gsapTimeline = tl

      tl.play(0)
    }, 500)
  },
  beforeDestroy() {
    console.log('RoundTheOutsideDiscovered beforeDestroy')
    this.gsapTimeline.kill()
    this.tapAnim.destroy()
  },
  methods: {
    debug() {
      debugger
    },
    buildArcs(button_span, button_gap) {
      const origin = document
        .getElementById('discover-button-5')
        .getBoundingClientRect()

      let origins = [
        'discover-button-7',
        'discover-button-5',
        'discover-button-3',
        'discover-button-1',
        'discover-button-9',
      ].reduce((s, x) => {
        s[x] = document.getElementById(x).getBoundingClientRect()
        return s
      }, {})

      // we modify the origin to make sure the tap finger is correctly offset when rotating
      const tapFingerRect = document
        .getElementById('discover-tap-finger')
        .getBoundingClientRect()
      origins['discover-tap-finger'] = {
        x: tapFingerRect.x + (origins['discover-button-7'].x - tapFingerRect.x),
        y: tapFingerRect.y + (origins['discover-button-7'].y - tapFingerRect.y),
      }

      this.origins = origins
      const r = Math.sqrt(
        (button_span + button_gap) ** 2 + (button_span + button_gap) ** 2
      )
      this.r = r
      const theta0 = Math.atan(
        -(button_span + button_gap) / (button_span + button_gap)
      )
      this.theta0 = theta0

      console.log(origin, r, theta0)

      const arc1 = buildArcPath(
        r,
        origins['discover-button-5'].x,
        origins['discover-button-5'].y,
        theta0,
        theta0 - Math.PI / 2
      )
      this.arc1 = new Bezier(
        arc1.p1.x,
        arc1.p1.y,
        arc1.c1.x,
        arc1.c1.y,
        arc1.c2.x,
        arc1.c2.y,
        arc1.p2.x,
        arc1.p2.y
      )

      const arc2 = buildArcPath(
        r,
        origins['discover-button-5'].x,
        origins['discover-button-5'].y,
        theta0 - Math.PI / 2,
        theta0 - Math.PI
      )

      this.arc2 = new Bezier(
        arc2.p1.x,
        arc2.p1.y,
        arc2.c1.x,
        arc2.c1.y,
        arc2.c2.x,
        arc2.c2.y,
        arc2.p2.x,
        arc2.p2.y
      )
    },
    moveButtons(pos) {
      const origin = this.origins['discover-button-5']
      const rotations = {
        'discover-button-1': -Math.PI / 2,
        'discover-button-9': (-3 * Math.PI) / 2,
      }

      const buttons_to_move = [
        'discover-button-1',
        'discover-button-9',
        'discover-button-7',
        'discover-button-5',
        'discover-button-3',
        'discover-tap-finger',
      ]

      buttons_to_move.forEach((b) => {
        let newPos = pos
        if (b in rotations) {
          newPos = rotateVector(newPos, rotations[b], origin)
        }
        this.updateButtonPosition(b, newPos.x, newPos.y, this.origins[b])
      })
    },
    updateButtonPosition(button_id, x, y, orig_pos) {
      const button = document.getElementById(button_id)
      gsap.set(button, {
        x: x - orig_pos.x,
        y: y - orig_pos.y,
      })
    },
  },
  watch: {
    rotation_t(new_val) {
      if (!(new_val === undefined)) {
        if (new_val > 0 && new_val < 0.5) {
          const newPos = this.arc1.get(new_val * 2)
          this.moveButtons(newPos)
        } else if (new_val >= 0.5) {
          const newPos = this.arc2.get((new_val - 0.5) * 2)
          this.moveButtons(newPos)
        }
      }
    },
  },
}
</script>

<style scoped>
.tap-finger {
  position: absolute;
  width: 75%;
  height: 75%;
  left: -13%;
  top: 60%;
}

.code-container {
  position: relative;
  color: #cdf4dd;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  row-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  /*margin-bottom: calc(clamp(2rem, 17.6vmin, 4.5rem));
  margin-top: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);*/
  /*column-gap: 0.75rem;*/
  /*row-gap: 0.75rem;*/
}

.code-button {
  /*width: 3rem; 
  height: 3rem;*/
  width: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  height: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  border-radius: 50%;
  border: 0.5px solid #cdf4dd;
  display: flex;
  justify-content: center;
  align-items: center;
  /*font-size: 2rem;*/
  font-size: calc(clamp(1rem, 8.8vmin, 2.5rem) / 1.5);
  font-family: 'Open Sans';
  font-weight: 100;
  cursor: pointer;
  user-select: none;
}

.explainer-text {
  font-family: 'Montserrat', sans-serif;
  color: #cdf4dd;
  margin-top: 2rem;
}

.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
